import { useCallback } from "react";
import { sanityContent } from "@helpers/sanity";

import { useSite } from "~/hooks/useSite";

export const useRichText = () => {
  const { locale } = useSite();

  const parseContent = useCallback(
    (content) => {
      return sanityContent(content, locale);
    },
    [locale],
  );

  return {
    parseContent,
  };
};
